export const rubros = [
	{
		
		"nombre": "1. Normatividad",
		"icono": "Normatividad.png",
		"formatos": [
			{
				"nombre": "Marco Normativo",
				"xlsx": "f01",
				"html": "f01",
			}
		],
	}, 
	{
		"nombre": "2. Estructura",
		"icono":"Estructura.png",
		"formatos": [
			{
				"nombre": "Estructura Orgánica",
				"xlsx": "f02_a",
				"html": "f02_a"
			},
			{
				"nombre": "Organigrama",
				"xlsx": "f02_b",
				"html": "f02_b"
			}
		]
	},
	{
		"nombre": "3. Facultades",
		"icono":"Facultades.png",
		"formatos": [
			{
				"nombre": "Facultades",
				"xlsx": "f03",
				"html": "f03"
			}
		]
	},
	{
		"nombre": "4. Programas Operativos Anuales",
		"icono":"ProgramasOperativosAnuales.png",
		"formatos": [
			{
				"nombre": "Metas y Objetivos",
				"xlsx": "f04",
				"html": "f04"
			}
		]
	},
	{
		"nombre": "5. Indicadores de Interés",
		"icono":"IndicadoresInteres.png",
		"formatos": [
			{
				"nombre": "Indicadores de Interés",
				"xlsx": "f05",
				"html": "f05"
			}
		]
	},
	{
		"nombre": "6. Matriz de Indicadores",
		"icono":"MatrizIndicadores.png",
		"formatos": [
			{
				"nombre": "Matriz de Indicadores",
				"xlsx": "f06",
				"html": "f06"
			}
		]
	},
	{
		"nombre": "7. Directorio",
		"icono":"Directorio.png",
		"formatos": [
			{
				"nombre": "Directorio",
				"xlsx": "f07",
				"html": "f07"
			}
		]
	},
	{
		"nombre": "8. Sueldos*",
		"icono":"Sueldos.png",
		"url" : "https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/8. Sueldos"
	},
	{
		"nombre": "9. Viáticos",
		"icono":"Viaticos.png",
		"formatos": [
			{
				"nombre": "Viáticos",
				"xlsx": "f09",
				"html": "f09"
			}
		]	
	},
	{
		"nombre": "10. Plazas*",
		"icono":"Plazas.png",
		"url" : "https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/10. Plazas"
	},
	{
		"nombre": "11. Honorarios",
		"icono":"Honorarios.png",
		"formatos": [
			{
				"nombre": "Personal de Honorarios",
				"xlsx": "f11",
				"html": "f11"
			}
		]	
	},
	{
		"nombre": "12. Declaraciones Públicas*",
		"icono":"DeclaracionesPublicas.png",
		"url" : "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/12.%20Declaraciones%20P%C3%BAblicas"	
	},
	{
		"nombre": "13 Datos de Contacto de la Unidad*",
		"icono":"DatosContactoUnidad.png",
		"url" : "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/13.%20Datos%20de%20Contacto%20de%20la%20Unidad"
	},
	{
		
		"nombre": "14. Convocatorias*",
		"icono":"Convocatorias.png",
		"url" : "https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/14. Convocatorias"
	},
	{
		"nombre": "15. Programas Sociales",
		"icono":"ProgramasSociales.png",
		"formatos": [
			{
				"nombre": "Programas de Subsidio, Estimulo y Apoyo",
				"xlsx": "f15_a",
				"html": "f15_a"
			},
			{
				"nombre": "Padrón de beneficiarios",
				"xlsx": "f15_b",
				"html": "f15_b"
			}
		]
	},
	{
		
		"nombre": "16. Relaciones Laborales*",
		"icono":"RelacionesLaborales.png",
		"url" : "https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/16. Relaciones%20Laborales"
	},
	{
		"nombre": "17. Información Curricular",
		"icono":"InformacionCurricular.png",
		"formatos": [
			{
				"nombre": "Información Curricular",
				"xlsx": "f17",
				"html": "f17"
			}
		]
	},
	{
		"nombre": "18 Sanciones Administrativas*",
		"icono":"SancionesAdministrativas.png",
		"url" : "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/18.%20Sanciones%20Administrativas"	
	},
	{
		"nombre": "19. Servicios",
		"icono":"Servicios.png",
		"formatos": [
			{
				"nombre": "Servicios",
				"xlsx": "f19",
				"html": "f19"
			}
		]
	},
	{
		"nombre": "20. Trámites",
		"icono":"Tramites.png",
		"formatos": [
			{
				"nombre": "Trámites",
				"xlsx": "f20",
				"html": "f20"
			}
		]
	},
	{
		"nombre": "21. Presupuesto e Informes Trimestrales*",
		"icono":"PresupuestoInformesTrimestrales.png",
		"url" : "https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/21.Presupuesto%20e%20Informes%20Trimestrales"
	},
	{
		"nombre": "22. Deuda Pública*",
		"icono":"DeudaPublica.png",
		"url" : "https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/22.Deuda%20P%C3%BAblica"
	},
	{
		"nombre": "23. Comunicación Social y Publicidad",
		"icono":"ComunicacionSocialPublicidad.png",
		"formatos": [
			{
				"nombre": "Programa Anual de Comunicación Social",
				"xlsx_liga": "https://s-gobierno.hidalgo.gob.mx/Transparencia/xlsx/a69f23aSEGOB.xlsx",
				"htm_liga": "https://s-gobierno.hidalgo.gob.mx/Transparencia/htm/a69f23aSEGOB.htm",
				"externo":"si"
			},
			{
				"nombre": "Erogación de Recursos de Comunicación Social",
				"xlsx": "f23_b",
				"html": "f23_b"
			},
			{
				"nombre": "Tiempos Oficiales",
				"xlsx_liga": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/RadioTVH/dir1/FC/a69_f23_c_RTH.xlsx",
				"htm_liga": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/RadioTVH/dir1/FC/a69_f23_c_RTH.htm",
				"externo":"si"
			}

		]
	},
	{
		"nombre": "24. Resultados de Auditorías*",
		"icono":"ResultadosAuditorias.png",
		"url" : "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/24.%20Resultados%20de%20Auditor%C3%ADas"
	},
	{
		"nombre": "25. Dictámines de Estados Financieros*",
		"icono":"DictamenesFinancieros.png",
		"url" : "https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/25.Dict%C3%A1menes%20de%20Estados%20Financieros"		
	},
	{
		"nombre": "26. Asignación de Recursos Públicos a Personas*",
		"icono":"AsignacionRecursosPublicosPersonas.png",
		"url" : "https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/26.Asignacion%20de%20Recursos%20Publicos%20a%20Personas"	
	},
	{
		"nombre": "27. Concesiones",
		"icono":"Concesiones.png",
		"formatos": [
			{
				"nombre": "Concesiones, Contratos, Convenios, Permisos, Licencias y Autorizaciones",
				"xlsx": "f27",
				"html": "f27"
			}
		]
	},
	{
		"nombre": "28. Licitaciones Públicas",
		"icono":"LicitacionesPublicas.png",
		"formatos": [
			{
				"nombre": "Procedimientos de Licitación Pública e Invitación a Cuando Menos Tres Personas",
				"xlsx": "f28",
				"html": "f28"
			}
		]
	},
	{
		"nombre": "29. Informes*",
		"icono":"Informes.png",
		"url" : "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/29.%20Informes"		
	},
	{
		"nombre": "30. Estadísticas Generadas",
		"icono":"EstadisticasGenerales.png",
		"formatos": [
			{
				"nombre": "Estadísticas",
				"xlsx": "f30",
				"html": "f30"
			}
		]
	},
	{
		"nombre": "31. Informe de Avances y Documentos Financieros*",
		"icono":"InformeAvancesDocumentosFinancieros.png",
		"url" : "https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/31.Informe%20de%20Avances%20y%20Documentos%20Financieros"			
	},
	{
		"nombre": "32. Padrón de Proveedores y Contratistas*",
		"icono":"PadronProveedoresContratistas.png",
		"url" : "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/32.%20Padr%C3%B3n%20de%20Proveedores%20y%20Contratistas"		
	},
	{
		"nombre": "33. Convenios con Sectores Social y Privado",
		"icono":"ConveniosSectoresSocialPrivado.png",
		"formatos": [
			{
				"nombre": "Convenios de Coordinación y Concertación",
				"xlsx": "f33",
				"html": "f33"
			}
		]
	},
	{
		"nombre": "34. Inventario de Bienes*",
		"icono":"InventarioBienes.png",
		"url" : "https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/34. Inventario%20de%20Bienes"			
	},
	{
		"nombre": "35. Recomendaciones y Atención en Materia de Derechos Humanos",
		"icono":"RecomendacionesAtenciónMateriaDerechosHumanos.png",
		"formatos": [
			{
				"nombre": "Recomendaciones de Derechos Humanos Emitidas por la CNDH",
				"xlsx": "f35_a",
				"html": "f35_a"
			},
			{
				"nombre": "Recomendaciones de Derechos Humanos Casos Especiales",
				"xlsx": "f35_b",
				"html": "f35_b"
			},
			{
				"nombre": "Las Recomendaciones de Derechos Humanos Org. Int. CNDH",
				"xlsx": "f35_c",
				"html": "f35_c"
			},
		]
	},
	{
		"nombre": "36. Resoluciones y Laudos de Juicios",
		"icono":"ResolucionesLaudosJuicios.png",
		"formatos": [
			{
				"nombre": "Resoluciones y Laudos ",
				"xlsx": "f36",
				"html": "f36"
			}
		]
	},
	{
		"nombre": "37. Mecanismo de Participación Ciudadana",
		"icono":"MecanismosParticipacionCiudadana.png",
		"formatos": [
			{
				"nombre": "Mecanismos de Participación Ciudadana",
				"xlsx": "f37_a",
				"html": "f37_a"
			},
			{
				"nombre": "Resultados de los Mecanismos de Participación Ciudadana",
				"xlsx": "f37_b",
				"html": "f37_b"
			}
		]
	},
	{
		"nombre": "38. Programas Ofrecidos",
		"icono":"ProgramasOfrecidos.png",
		"formatos": [
			{
				"nombre": "Programas que Ofrecen",
				"xlsx": "f38_a",
				"html": "f38_a"
			},
			{
				"nombre": "Tramites a los Programas que Ofrecen",
				"xlsx": "f38_b",
				"html": "f38_b"
			}
		]
	},
	{
		"nombre": "39. Actas y Resoluciones del Comité de Transparencia*",
		"icono":"ActasResolucionesComiteTransparencia.png",
		"url" : "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/39.%20Actas%20y%20Resoluciones%20del%20Comit%C3%A9%20de%20Transparencia"		
	},
	{
		"nombre": "40. Evaluacion y Encuesta a Programas Financiados con Recursos Públicos*",
		"icono":"EvaluacionencuestasProgramas.png",
		"url" : "https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/40.Evaluacion%20y%20Encuestas%20a%20Programas%20Financiados%20con%20Recursos%20P%C3%BAblicos"		
	},
	{
		"nombre": "41. Estudios Pagados con Recursos Públcos*",
		"icono":"EstudiosPagadosRecursosPublicos.png",
		"url" : "https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/41.Estudios%20Pagados%20con%20Recursos%20P%C3%BAblicos"
	},
	{
		"nombre": "42. Listados Jubilados y Pensionados*",
		"icono":"ListadoJubiladosPencionados.png",
		"url" : "https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/42. Listados%20Jubilados%20y%20Pensionados"
	},
	{
		"nombre": "43. Ingresos Recibidos por Cualquier Concepto*",
		"icono":"IngresosRecibidosCualquierConcepto.png",
		"url" : "https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/43.Ingresos%20Recibidos%20por%20Cualquier%20Concepto"
	},
	{
		"nombre": "44. Donaciones Hechas a Terceros",
		"icono":"DonacionesHechasTerceros.png",
		"formatos": [
			{
				"nombre": "Donaciones hechas a Terceros en Dineros",
				"xlsx": "f44",
				"html": "f44"
			}
		]	
	},
	{
		"nombre": "45. Catálogo Documental y Guia de Archivos",
		"icono":"Viaticos.png",
		"formatos": [
			{
				"nombre": "Inventarios Documentales",
				"xlsx": "f45_a",
				"html": "f45_a"
			},{
				"nombre": "Índice de expedientes clasificados",
				"xlsx_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/xls/a69_f45b_SC.xlsx",
				"htm_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/htm/a69_f45b_SC.htm",
				"externo":"si"

			},{
				"nombre": "Instrumentos Archivisticos",
				"xlsx": "f45_c",
				"html": "f45_c"
			}
		]
	},
	{
		"nombre": "46. Actas de Sesiones, Opiniones y Recomendaciones de Consejos Consultivos*",
		"icono":"CatalogoDocumentalGuiaArchivos.png",
		"url" : "https://s-turismo.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/46.Actas%20de%20Sesiones,%20Opiniones%20y%20Recomendaciones%20de%20Consejos%20Consultivos"		
	},
	{
		"nombre": "47. Solicitud de Intervecion de  Comunicaciones*",
		"icono":"SolicitudIntervencionComunicaciones.png",
		"url" : "https://procuraduria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/Solicitud%20de%20Intervenci%C3%B3n%20de%20%20Comunicaciones"		
	},
	{
		"nombre": "48. Información de Utilidad o Relevante",
		"icono":"InformacionUtilidadRelevante.png",
		"formatos": [
			{
				"nombre": "Interés Público",
				"xlsx": "f48_a",
				"html": "f48_a"
			},
			{
				"nombre": "Preguntas Frecuentes",
				"xlsx": "f48_b",
				"html": "f48_b"
			},
			{
				"nombre": "Transparencia Proactiva",
				"xlsx": "f48_c",
				"html": "f48_c"
			}
		]
	},
]